import { jsx as s } from "react/jsx-runtime";
import { c as a } from "./Section-DOeCOW54.js";
import n from "react";
const i = "elo-link", c = "elo-tablet", m = "elo-mobile", r = {
  link: i,
  tablet: c,
  mobile: m
}, x = n.forwardRef(
  ({ children: l, ...t }, o) => {
    const e = a(t.className, r.link);
    return /* @__PURE__ */ s("a", { ...t, ref: o, className: e, children: l });
  }
);
export {
  x as L
};
